export default __webpack_public_path__ + "static/media/search_products.96de979c.jpg";